import Breadcrumb from '@/components/breadcrumb';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { PlusIcon } from 'lucide-react';
import { ComplaintListing } from './components/ComplaintsListing';


export type ManageComplaintsProps = {
  organizationId: string;
};

export const ManageComplaints = ({
  organizationId,
}: ManageComplaintsProps) => {

  const org = useStore($org);

  const pages = [
    {
      label: org?.name || 'Organizations',
      href: org?.name
        ? `/organization/${org?.id}/complaints`
        : '/organizations',
    },
    {
      label: 'Complaints',
      href: `/organization/${org?.id}/complaints`,
    },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Complaints Management</h2>
          <p className="text-muted-foreground">
            {`List of complaints for ${org?.name}.`}
          </p>
        </div>
      </div>

      <div className="mt-4 max-w-4xl">
        <ComplaintListing />
      </div>
    </div>
  );
};